import { useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import SummaryCounts from './SummaryCounts';
import DashboardAccordianItem from './DashboardAccordianItem';
import ApplicationsOverTime from './ApplicationsOverTime';
import JobTypeDistribution from './JobTypeDistribution';
import JobByLocation from './JobByLocation';
import ExperienceLevelDistribution from './ExperienceLevelDistribution';
import TopHiringCompanies from './TopHiringCompanies';
import EngagementMetrics from './EngagementMetrics';
import HotJobs from './HotJobs';
import TrendingJobs from './TrendingJobs';
import RecentActivitySummary from './RecentActivitySummary';
import AverageSalaryRangeByExperience from './AverageSalaryRangeByExperience';

const JobDashboard = () => {
    const { state, dispatch } = useContext(SmartContext);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <div
                className="flex-1 polarcontsec tab-content aos-init aos-animate"
                id="myTabContent"
                data-aos="fade-left"
                data-aos-delay="900">
                <div className="tab-pane fade show active" id="JobListing" role="tabpanel" aria-labelledby="JobListing-tab">
                    <div className="ActiveListings_present">
                        <h3 className="font-18 font-500 mb-3 d-none d-md-block">Dashboard</h3>
                            <div className="row g-3">
                                <SummaryCounts />
                                <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'APPLICATIONS_OVER_TIME'}
                                    title="Applications over Time (Monthly)"
                                    // tooltip=""
                                    >
                                    <ApplicationsOverTime />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'JOB_TYPE_DISTRIBUTION'}
                                    title="Job Type Distribution"
                                    // tooltip=""
                                    >
                                    <JobTypeDistribution />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'JOB_BY_LOCATION'}
                                    title="Job By Location"
                                    // tooltip=""
                                    >
                                    <JobByLocation />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'EXPERIENCE_LEVEL_DISTRIBUTION'}
                                    title="Experience Level Distribution"
                                    // tooltip=""
                                    >
                                    <ExperienceLevelDistribution />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'AVERAGE_SALARY_RANGE_BY_EXPERIENCE'}
                                    title="Average Salary Range By Experience"
                                    // tooltip=""
                                    >
                                    <AverageSalaryRangeByExperience />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'TOP_HIRING_COMPANIES'}
                                    title="Top Hiring Companies"
                                    // tooltip=""
                                    >
                                    <TopHiringCompanies />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'ENGAGEMENT_METRICS'}
                                    title="Engagement Metrics"
                                    // tooltip=""
                                    >
                                    <EngagementMetrics />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'HOT_JOBS'}
                                    title="Hot Jobs (Most Applications)"
                                    // tooltip=""
                                    >
                                    <HotJobs />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6'>
                                <DashboardAccordianItem
                                    reportKey={'TRENDING_JOBS'}
                                    title="Trending Jobs (Most Interest)"
                                    // tooltip=""
                                    >
                                    <TrendingJobs />
                                </DashboardAccordianItem>
                            </div>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <DashboardAccordianItem
                                    reportKey={'RECENT_ACTIVITY_SUMMARY'}
                                    title="Recent Activity Summary"
                                    // tooltip=""
                                    >
                                    <RecentActivitySummary />
                                </DashboardAccordianItem>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SmartContext.Provider>
    );
};

export default JobDashboard;